import Maybe from 'components/__new/common/Maybe';
import FormDrawer from 'components/__new/common/form-drawer'
import moment from 'moment';
import CurrencyFormat from 'utils/currencyFormat'
import { TimeFormat } from 'utils/dateFormat';
import numberOrdinalSuffix from 'utils/numberOrdinalSuffix';


const ViewRecurringTransferDetails = ({isOpen, setIsOpen, selected}) => {
    
    const wrapperClass = "mb-4";
    const titleClass = "text-ep-gray-500";
    const subtitleClass = "text-ep-gray-700"
    
    // console.log('selected', selected)
    
    return (
        <FormDrawer display="center" size="2xl" isOpen={isOpen} setIsOpen={() => {}}>
            <div className="p-6">
                <FormDrawer.Title
                    title={<span className='capitalize'>{selected?.name}</span>}
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <hr className="w-full h-px mt-2 bg-[#E2E4E8] border-none" />
                
                <div className="p-3 mt-5 w-full bg-[#d1d5db] bg-opacity-40 rounded-lg">
                    <div className="text-ep-gray-700">
                        Recurring Transfer Details
                    </div>
                    
                    <div className="w-full bg-white rounded-lg p-3 mt-3">
                        <div>
                            <p className="mb-1 text-ep-gray-500">Amount</p>
                            <p className="text-ep-gray-700 text-lg lg:text-2xl font-medium">
                                {CurrencyFormat(selected?.amount)}
                            </p>
                        </div>
                        
                        <div className="w-full mt-5">
                            <div className="flex items-start justify-between text-sm">
                                
                                <div className='w-[47%]'>
                                    <div className={wrapperClass}>
                                        <p className={titleClass}>Paid When</p>
                                        <p className={subtitleClass}>
                                            <Maybe condition={selected?.frequency === 'daily'}>
                                                Daily, at {selected?.time}
                                            </Maybe>
                                            
                                            <Maybe condition={selected?.frequency === 'weekly'}>
                                                Weekly on&nbsp;
                                                <span className="capitalize">{selected?.dayOfWeek}s&nbsp;</span>
                                                at {selected?.time}
                                            </Maybe>
                                            
                                            <Maybe condition={selected?.frequency === 'monthly'}>
                                                Monthly on the {numberOrdinalSuffix(selected?.dayOfMonth)}
                                            </Maybe>
                                        </p>
                                    </div>
                                    <div className={wrapperClass}>
                                        <p className={titleClass}>End Date</p>
                                        <p className={subtitleClass}>{moment(selected?.endDate)?.format("DD/MM/YYYY")}</p>
                                    </div>
                                </div>
                                
                                <div className='w-[47%]'>
                                    <div className={wrapperClass}>
                                        <p className={titleClass}>Start Date</p>
                                        <p className={subtitleClass}>{moment(selected?.startDate)?.format("DD/MM/YYYY")}</p>
                                    </div>
                                    <div>
                                        <p className={titleClass}>Amount of Transfers Completed</p>
                                        <p className={subtitleClass}>{selected?.transfersCompleted || "N/A"}</p>
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="p-3 mt-3 w-full bg-[#d1d5db] bg-opacity-40 rounded-lg">
                    <div className="text-ep-gray-700">
                        Recipient Details
                    </div>
                    
                    <div className="w-full bg-white rounded-lg p-3 mt-3">
                        <div className="w-full">
                            <div className="flex items-start justify-between text-sm">
                                
                                <div className='w-[47%]'>
                                    <div className={wrapperClass}>
                                        <p className={titleClass}>Recipient Name</p>
                                        <p className={subtitleClass + " capitalize"}>{selected?.recipient?.accountName?.toLowerCase() || "N/A"}</p>
                                    </div>
                                    <div className={wrapperClass}>
                                        <p className={titleClass}>Bank Name</p>
                                        <p className={subtitleClass + " capitalize"}>{selected?.recipient?.bankName?.toLowerCase() || "N/A"}</p>
                                    </div>
                                    <div>
                                        <p className={titleClass}>Next Transfer Date</p>
                                        <p className={subtitleClass}> {moment(selected?.nextTransfer)?.format("DD/MM/YYYY")} at {TimeFormat(selected?.nextTransfer)}</p>
                                    </div>
                                </div>
                                
                                <div className='w-[47%]'>
                                    <div className={wrapperClass}>
                                        <p className={titleClass}>Account Name</p>
                                        <p className={subtitleClass + " capitalize"}>{selected?.recipient?.accountName?.toLowerCase() || "N/A"}</p>
                                    </div>
                                    <div className={wrapperClass}>
                                        <p className={titleClass}>Last Transfer Date</p>
                                        <p className={subtitleClass}>{selected?.lastTransfer || "N/A"}</p>
                                    </div>
                                    <div>
                                        <p className={titleClass}>Transfer Frequency</p>
                                        <p className={subtitleClass + " capitalize"}>{selected?.frequency}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FormDrawer>
    )
}

export default ViewRecurringTransferDetails